// Centralized query key factory for stable keys
// Usage: useQuery({ queryKey: keys.health(), queryFn: ... })

export const keys = {
  health: () => ['health'] as const,
  eventOwners: {
    all: () => ['eventOwners'] as const,
    list: () => [...keys.eventOwners.all(), 'list'] as const,
    detail: (id: string) => [...keys.eventOwners.all(), 'detail', id] as const,
  },
  events: {
    all: () => ['events'] as const,
    list: () => [...keys.events.all(), 'list'] as const,
    detail: (id: string) => [...keys.events.all(), 'detail', id] as const,
    formData: {
      new: () => [...keys.events.all(), 'new', 'form-data'] as const,
      edit: (id: string) => [...keys.events.all(), 'edit', id, 'form-data'] as const,
    },
  },
  categories: {
    all: () => ['categories'] as const,
    list: () => [...keys.categories.all(), 'list'] as const,
    detail: (id: string) => [...keys.categories.all(), 'detail', id] as const,
  },
  eventUserManagement: {
    all: (slug: string) => ['eventUserManagement', slug] as const,
    list: (slug: string) => [...keys.eventUserManagement.all(slug), 'list'] as const,
    search: (slug: string, query: string) =>
      [...keys.eventUserManagement.all(slug), 'search', query] as const,
  },
  // The e-certificate designer's preview-subject picker. Read-only and scoped to
  // one event, so the slug sits in `all()` the way user management's does.
  certificatePreviewRegistrants: {
    all: (slug: string) => ['certificatePreviewRegistrants', slug] as const,
    search: (slug: string, query: string) =>
      [...keys.certificatePreviewRegistrants.all(slug), 'search', query] as const,
  },
}
